import axios from 'axios';
import { Headers as HeadersConsts } from '@sparrow-card/sparrow-card-constants';
import applicationConfig from 'config/applicationConfig';
import { store } from 'stores';

export const setupAxiosInterceptor = () => {
  axios.interceptors.request.use((config) => {
    config.headers.set(HeadersConsts.XTransactionId, applicationConfig.transactionId);
    config.headers.set(HeadersConsts.XSessionId, applicationConfig.sessionId);

    const portalType = store.getState()?.application?.portalType;

    if (portalType) {
      config.headers.set(HeadersConsts.XPortalType, portalType);
    }

    return config;
  });
};

export default setupAxiosInterceptor;
